import { ENUM_ACTIVE_CHECKBOX, ENUM_IMAGE_LAYOUT } from 'constants/enum';
import { TEXT_COMMON, TEXT_CREATE_SURVEY } from 'constants/string/texts';

const Required = require('assets/resources/Required.svg').default;

export const ImagePreview = ({ data }) => {
  if (!data?.images?.[0]) return null;

  return (
    <div className="w-full" style={{ display: 'flex', justifyContent: data.images?.[0]?.image_layout ?? ENUM_IMAGE_LAYOUT.LEFT }}>
      <img
        src={data.images?.[0].url_preview}
        alt="Image Preview"
        style={{ width: data.images?.[0]?.size?.width, height: data.images?.[0]?.size?.height }}
        className="image-preview mb-3"
      />
    </div>
  );
};

/**
 * If you are not focused on the question, you will display this place.On the contrary,
 * this place will show this place <Optionals [enum_Question_type.Select_Question]>
 */
export const ImagePreviewContainer = (props) => {
  const { data } = props;

  const imagePreview = data.images?.[0];
  return (
    <div className="w-full" style={{ display: 'flex', justifyContent: imagePreview?.image_layout ?? ENUM_IMAGE_LAYOUT.LEFT }}>
      <div className="image-preview-container">
        <img
          src={imagePreview?.url_preview}
          alt="Image Preview"
          style={{ width: imagePreview?.size?.width, height: imagePreview?.size?.height }}
          className="image-preview"
        />
      </div>
    </div>
  );
};

{
  /* If this question structure is not in the editing state, there is no show this part */
}
export const TitlePreview = (props) => {
  const { data } = props;

  const titleNumber = data.question_number ? TEXT_COMMON.QUESTION_NUMBER.replace('${question_number}', data.question_number) : '';
  const title = data?.title.replace(/\r\n/g, '<br />') || TEXT_CREATE_SURVEY.TITLE_PARAGRAPH;

  return (
    <p className="text-sm text-black-102 mb-1 flex items-start gap-1 break-all">
      {data.is_required && <img className="mt-2" src={Required} alt="required" width={7} height={7} />}
      <span dangerouslySetInnerHTML={{ __html: `${titleNumber}${title}` }} />
    </p>
  );
};

export const DescriptionPreview = (props) => {
  const { data } = props;

  return (
    data.active_checkbox?.indexOf(ENUM_ACTIVE_CHECKBOX.EXPLANATION) !== -1 &&
    data.description && <p className="text-xs text-black-102 mb-2.5 break-all">{data.description || ''}</p>
  );
};
